class GeoLocator {
  repository = {};

  constructor() {}

  load(wpDeployEnv) {
    let repository = this.repository;
    let instance = this;

    const url =
      wpDeployEnv === "production"
        ? "https://api2.digital.silversea.com/ViewerGeoLocation"
        : "https://dev-api2.digital.silversea.com/ViewerGeoLocation";

    return new Promise(function (resolve, reject) {
      fetch(url)
        .then(function (response) {
          return response.json();
        })
        .then(function (json) {
          Object.assign(repository, json);
          resolve(instance);
        })
        .catch(function (ex) {
          reject(instance);
          console.log("parsing failed", ex);
        });
    });
  }

  get countryISO2() {
    return this.repository.countryCode;
  }

  get countryISO3() {
    return this.repository.iso3Code;
  }

  get market() {
    return this.repository.market;
  }

  get currency() {
    return this.repository.defaultCurrency;
  }

  get AAMarket() {
    if (
      this.repository.countryCode === "US" ||
      this.repository.countryCode === "CA"
    )
      return "US";
    if (this.repository.market === "FT") return "LAM";
    if (this.repository.market === "AS") return "AP";
    if (this.repository.market === "EU") return "EMEA";
    return this.repository.market;
  }
}
export default new GeoLocator();
